


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const getUsersReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.GET_ALL_USER:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.GET_ALL_USER_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.GET_ALL_USER_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
